import { React, useState, useEffect } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import download from "../../../assets/AddAssets/assets/images/download.png";
import bagshop from "../../../assets/AddAssets/assets/images/bag_shop.png";
import user from "../../../assets/AddAssets/assets/images/user.png";
import logout from "../../../assets/AddAssets/assets/images/logout.png";
import cashOut from "../../../assets/AddAssets/assets/images/cashout-icon.png";
import menu from "../../../assets/AddAssets/assets/images/menu.svg";
import close from "../../../assets/AddAssets/assets/images/close.svg";
import { useRef } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import GetStorage from "../../../services/storage";
import { useDispatch, useSelector } from "react-redux";
import { getUser } from "../../../store/api/userEdit";
import {
  getCoin,
  getProductToCart,
  getPromotion,
  getEligibilityPromotion,
} from "../../../store/api/cart";
import { getUsersCardApi } from "../../../store/api/payment";
import SocketService from "../../../services/socket.service";
import { setEditUser } from "../../../store/auth/eidtProfile";
import storage from "../../../services/storage";
import Toast from "../../Toastify/Toastify";
import lionsLogo from "../../../assets/images/headercreationlogo.png";
import coinLogo from "../../../assets/coin.png";
import NavItemWithSubmenu from "./components/GetTheAppHeaderWeb";
import back from "./../../../assets/images/back.png";
import { getActivePot } from "../../../store/api/ticketingPot";
const HeaderSatalite = () => {
  const dispatch = useDispatch();
  const { image, coins } = useSelector((state) => state?.editUser?.user) || {};
  const { activePotData } = useSelector((state) => state.TicketingPot);
  const {isMainSite} = useSelector((state) => state.domain);
  const { attempts, decision, status } =
    useSelector((state) => state?.user?.jumio) || {};
  // console.log('attempts', attempts)
  const badge =
    decision === "PASSED"
      ? "Verified"
      : status === "INITIATED" || status === "ACQUIRED"
        ? "Pending"
        : "Retry";
  const [isDropDownVisible, setIsDropDownVisible] = useState(false);
  const { cart = [], promotion } = useSelector((state) => state.cart);
  const closeLogout = useRef(null);
  const closeOutsideMob = useRef(null);
  // handleSearchButtonClick useState
  const [showSearchInput, setShowSearchInput] = useState(false);
  // menu useState
  const [menuVisible, setMenuVisible] = useState(false);
  const [showSubmenu, setShowSubmenu] = useState(false);
  const [showMblSubmenu, setMblSubmenu] = useState(false);
  // console.log('promotion', promotion)
  let duaWalCoins =
    coins?.purchasedWallet + coins?.winWallet + coins?.stackingWallet;
  // console.log('activePotData ===>', activePotData);
  useEffect(() => {
    dispatch(
      getProductToCart({
        onSuccess: (res) => {
          // console.log("cart===>", res.data);
        },
        onError: (err) => {
          // console.log("rrr", err);
          if (err?.response?.status === 401) {
            storage.remove("xAuthToken");
            storage.remove("user");
            Toast.error(err.response.data, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "dark",
            });
          }
        },
      })
    );
    dispatch(
      getCoin({
        onSuccess: (res) => {
          // console.log("coin===>", res.data);
        },
      })
    );
    if (isMainSite === true) {
      dispatch(
        getPromotion({
          onSuccess: (res) => {
            // console.log("promotion ===>", res.data.promotion);
          },
        })
      );
      dispatch(
        getEligibilityPromotion({
          onSuccess: (res) => {
            // console.log("eligibility promotion ===>", res.data.promotion);
          },
        })
      );
      dispatch(
        getActivePot({
          onSuccess: () => { },
  
          onError: () => { },
        })
      );
    }
  }, [dispatch]);
  useEffect(() => {
    dispatch(getUser({}));
  }, [dispatch]);
  useEffect(() => {
    dispatch(getUsersCardApi({}));
  }, [dispatch]);
  const NumberTokG = (num) => {
    if (num < 10000) {
      let cNum = Number(num);
      return cNum.toFixed(2);
    }
    return `${new Intl.NumberFormat("en-US", {
      maximumFractionDigits: 2,
      notation: "compact",
      compactDisplay: "short",
    }).format(num)}`;
  };
  useOutsideAlerter(closeLogout, () => setIsDropDownVisible(false));
  useOutsideAlerter(closeOutsideMob, () => setMenuVisible(false));
  const handleLogout = () => {
    setIsDropDownVisible(!isDropDownVisible);
  };
  const handleOpenClick = () => {
    setMenuVisible(true);
  };
  const handleCloseClick = () => {
    setMenuVisible(false);
  };
  const navigate = useNavigate();
  const signOutUser = () => {
    try {
      // storageService.remove("user");
      GetStorage.remove("xAuthToken");
      GetStorage.remove("user");

      SocketService.disconnect();
      dispatch(setEditUser());
      // storageService.remove("xAuth");
      // console.log("rem=== ", token);
      navigate("/");
    } catch (e) { }
  };
  const handleShowMblMenu = () => {
    setMblSubmenu(true);
  };

  const handleCloseMblMenu = () => {
    setMblSubmenu(false);
  };

  // const handleRedeemBox = () => {
  //   setRedeemBox(true);
  // };
  // const handleRedeemBoxBack = () => {
  //   setRedeemBox(false);
  // };
  return (
    <>
      <header className="header_wrap pt_70 ">
        <div className="theme-container   ">
          <div className="header_inner">
            <div className="nav_list">
              <ul className="d-flex">
                <li
                  className="nav-item"
                  onMouseEnter={() => setShowSubmenu(false)}
                >
                  <Link
                    to={"/products"}
                    className="f_24 fw-600 text-white mr_40 cus_mr_20 nav-link"
                  >
                    Products
                  </Link>
                </li>
                {activePotData && (
                  <li
                    className="nav-item"
                    onMouseEnter={() => setShowSubmenu(false)}
                  >
                    <Link
                      to={"/raffle-ticket"}
                      className="f_24 fw-600 text-white mr_40 cus_mr_20 nav-link"
                    >
                      Raffle Ticket
                    </Link>
                  </li>
                )}

                {/* <li
                  className="nav-item"
                  onMouseEnter={() => setShowSubmenu(false)}
                >
                  <Link
                    to={"/gift-cards"}
                    className="f_24 fw-600 text-white mr_40 cus_mr_20 nav-link"
                  >
                    Gift Cards
                  </Link>
                </li> */}
                <li
                  className="nav-item"
                  onMouseEnter={() => setShowSubmenu(false)}
                >
                  <Link
                    to={"/about-us"}
                    className="f_24 fw-600 text-white mr_40 cus_mr_20 nav-link"
                  >
                    About
                  </Link>
                </li>
                <NavItemWithSubmenu
                  showSubmenu={showSubmenu}
                  setShowSubmenu={setShowSubmenu}
                />
              </ul>
            </div>
            <div className="nav_logo text-center">
              <img
                onClick={() => navigate("/")}
                src={lionsLogo}
                className="logo_main"
                alt="logo"
              />
            </div>
            <div className="logout_wrap">
              <div className="icon d-flex">
                <Link to="/my-purchases" className="circal_box">
                  <img src={download} alt="download" />
                </Link>
                <Link to="/cart" className="circal_box">
                  <img src={bagshop} alt="bag_shop" />
                  <span className="number">{cart?.items?.length || 0}</span>
                </Link>
              </div>
              <Dropdown className="user_profile_wrap">
                <Dropdown.Toggle
                  id="dropdown-basic"
                  className="user_profile_btn"
                >
                  <img src={image ? image : user} alt="user" />
                </Dropdown.Toggle>
                <Dropdown.Menu className="drop_down">
                  <Dropdown.Item className="btn_logout">
                    {" "}
                    <img src={coinLogo} alt="logout" />{" "}
                    {duaWalCoins ? NumberTokG(duaWalCoins) : 0}
                  </Dropdown.Item>
                  {/* <Dropdown.Item
                    className="btn_logout"
                    as={Link}
                    to="/request-cashout"
                  >
                    <img src={cashOut} alt="cashout" /> Cashout
                  </Dropdown.Item> */}
                  <Dropdown.Item className="btn_logout" onClick={signOutUser}>
                    <img src={logout} alt="logout" /> Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              {attempts && (
                <div
                  className={`jumio_status desk_status`}
                  style={{
                    backgroundColor:
                      badge === "Retry"
                        ? "red"
                        : badge === "Pending"
                          ? "yellow"
                          : "",
                  }}
                  onClick={() => badge === "Retry" && navigate("/verify")}
                >
                  {badge}
                </div>
              )}
            </div>
          </div>
        </div>
      </header>

      {/* mobile_menu_wrap */}
      <div className="mobile_menu_wrap">
        <div
          className="menu_wrap_inner"
          style={{ display: menuVisible ? "block" : "none" }}
        >
          {menuVisible && !showMblSubmenu && (
            <div className="menu_list mobile-menu">
              <ul className="footer-list">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/products">Products</Link>
                </li>
                {activePotData && (
                  <li>
                    <Link to="/raffle-ticket">Raffle Ticket</Link>
                  </li>
                )}

                {/* <li>
                  <Link to="/gift-cards">Gift Cards</Link>
                </li> */}
                <li>
                  <Link to="/about-us">About</Link>
                </li>
                <li
                  onClick={handleShowMblMenu}
                  className="mbl-header-get_app pointer center-menu"
                >
                  <span>Get the App</span>
                </li>
              </ul>
            </div>
          )}
          {menuVisible && showMblSubmenu && (
            <div className="menu_list mobile-menu">
              <button
                type="button"
                onClick={handleCloseMblMenu}
                className="back_redeem"
              >
                <img src={back} alt="back" />
                <p className="redeem_back_p">Back</p>
              </button>
              <ul className="footer-list">
                <li>
                  <Link
                    target="_blank"
                    rel="noopener noreferrer"
                    to="https://www.lionsdengames.net/download-ios"
                  >
                    IOS
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    rel="noopener noreferrer"
                    to="https://www.lionsdengames.net/download-android"
                  >
                    Android
                  </Link>
                </li>
              </ul>
            </div>
          )}
          <button
            className="BtnClose"
            onClick={handleCloseClick}
            style={{ display: menuVisible ? "inline-block" : "none" }}
          >
            <img src={close} alt="close" />
          </button>
          <div className="logout_wrap">
            <div className="icon d-flex">
              <Link to={"/my-purchases"} className="circal_box">
                <img src={download} alt="download" />
              </Link>
              <Link to={"/cart"} className="circal_box">
                <img src={bagshop} alt="bag_shop" />
                <span className="number">{cart?.items?.length || 0}</span>
              </Link>
            </div>

            {/* <div className="user_profile_wrap">
              <button
                type="button"
                className="user_profile_btn"
                onClick={handleLogout}
              >
                <img src={image ? image : user} alt="user" />
              </button>

              {isDropDownVisible && (
                <div className="drop_down">
                  <button className="btn_logout">
                    <img src={coinLogo} alt="logout" />{" "}
                    {gems ? NumberTokG(gems) : 0}
                  </button>
                  <button className="btn_logout" onClick={signOutUser}>
                    <img src={logout} alt="logout" /> Logout
                  </button>
                </div>
              )}
            </div> */}
            <Dropdown className="user_profile_wrap">
              <Dropdown.Toggle
                // variant="success"
                id="dropdown-basic"
                className="user_profile_btn"
              >
                <img src={image ? image : user} alt="user" />
              </Dropdown.Toggle>

              <Dropdown.Menu className="drop_down">
                <Dropdown.Item className="btn_logout">
                  {" "}
                  <img src={coinLogo} alt="logout" />{" "}
                  {duaWalCoins ? NumberTokG(duaWalCoins) : 0}
                </Dropdown.Item>
                {/* <Dropdown.Item
                    className="btn_logout"
                    as={Link}
                    to="/request-cashout"
                  >
                    <img src={cashOut} alt="cashout" /> Cashout
                  </Dropdown.Item> */}
                <Dropdown.Item className="btn_logout" onClick={signOutUser}>
                  <img src={logout} alt="logout" /> Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            {attempts && (
              <div className={`jumio_status`}>
                <div
                  className={``}
                  style={
                    {
                      // backgroundColor:
                      //   badge === "Retry"
                      //     ? "red"
                      //     : badge === "Pending"
                      //     ? "yellow"
                      //     : "",
                    }
                  }
                  onClick={() => badge === "Retry" && navigate("/verify")}
                >
                  {badge}
                </div>
              </div>
            )}
          </div>
        </div>
        <button
          // ref={closeOutsideMob}
          className="BtnOpen"
          onClick={handleOpenClick}
          style={{ display: menuVisible ? "none" : "inline" }}
        >
          <img src={menu} alt="open" />
          <span>Menu</span>
        </button>
      </div>
    </>
  );
};

export default HeaderSatalite;

function useOutsideAlerter(ref, cb) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        cb?.();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}
